import i18n from '../translations/i18n';
import {
  fieldsAllowedCountries,
  hiddenField,
  paramsAdd,
  paramsEdit
} from '../constants/form';
import { mediaPNG } from '../constants/files';
import { moduleCategory } from './tier';
import { searchStaticData } from './staticData';
import {
  fieldAttribute,
  fieldsUniqueName,
  fieldUniqueName,
  isEmpty,
  isUndefinedNull,
  notUndefinedNull,
  sortElement,
  trimLowerCase,
  trimUpperCase,
  datePattern
} from './shared';
import { store } from '../redux/store/store';
import { USER_APP_ORIGIN } from '../redux/types/user';
import { checkValue } from './conditions';
import { setMessage } from '../redux/actions/message';
import { sendGetEndpointData } from '../redux/actions/base';
import { setFileCases } from './files';
import { languagueEs } from '../constants/base';
import { appsOrigin } from '../constants/appOrigin';

/**** Export functions  ****/
/**
 * Validate app origin
 * @param {Object} lastAppOrigin
 * @param {String} param
 * @param {Boolean} isAuthenticated
 * @returns
 */
export const validateAppOrigin = (lastAppOrigin, param, isAuthenticated) => {
  const { appParam } = getAppOrigin(param);

  if (notUndefinedNull(isAuthenticated)) {
    if ((lastAppOrigin !== appParam || !notUndefinedNull(
      lastAppOrigin)) && !isAuthenticated) {
      const appOrigin = appParam;
      store.dispatch({ type: USER_APP_ORIGIN, payload: appOrigin });
    }
  }

};

/**
 * Save field
 * @param {Object} field
 * @param {Object} fieldSelect
 * @returns
 */
export const saveFieldValue = (field, fieldSelect) => {
  const { data: personData } = store.getState().personData;
  const allField = [...fieldSelect];
  const fieldObject = JSON.parse(field.dataset?.object);
  const name = field.name.split('__id__').shift().split('__').pop();
  const index = Array.from(allField).findIndex(
    elem => elem[name]?.toString() === fieldObject?.idValue.toString());
  const newObject = {
    user: personData.id
  };
  newObject[name] = fieldObject?.idValue;

  return { allField, newObject, index };
};

/**
 * Create File
 * @param {Object} dataURI
 * @param {String} fileName
 * @returns
 */
export const dataURItoBlob = (dataURI, fileName) => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // New Code
  const blob = new Blob([ab], { type: mimeString });
  const file = new File([blob], fileName, { type: mediaPNG });

  return file;
};

/**
 * Get if field show or not
 * @param {String} field
 * @returns
 */
export const getShowField = field => {
  const { appOrigin } = store.getState().user;
  const condition = (field?.parent_condition) ? JSON.parse(
    field.parent_condition) : field?.parent_condition;
  let response = true;

  if (notUndefinedNull(condition?.app)) {
      response = Array.from(condition.app).some(item => item === appOrigin);
  }
  if (notUndefinedNull(condition?.app_except)) {
    response = !Array.from(condition?.app_except).some(item => item === appOrigin)
  }

  return response;
};

/**
 * Validate where to get the data from
 * @param {String} typeData
 * @param {Object} getValues
 * @param {Boolean} isStart
 * @param {Function} setValue
 * @returns
 */
export const sendData = (
  typeData,
  getValues,
  isStart,
  setValue = null,
  changeOptionsValue = null,
  values
) => {
  const { data: personData } = store.getState().personData;
  const base = store.getState().base;
  const { actualLanguage } = base;
  const { [`data_${trimLowerCase(
    actualLanguage)}`]: staticData } = store.getState().staticData;
  let response;

  if (typeData === 'static_data') {
    response = (isStart) ? validateData(getValues, staticData) : searchData(
      getValues, staticData.field, setValue);
  } else if (typeData === 'person_data') {
    response = validateData(getValues, personData);
  } else if (typeData === 'base') {
    response = (isStart) ? validateData(getValues, base) : searchData(
      getValues, staticData.field, setValue);
  } else if (typeData === 'date_option'){
    response = validateDateOption(getValues, changeOptionsValue, typeData)
  } else if (typeData === 'date_auto_option') {
    response = calculateAutoDateValues(getValues, changeOptionsValue, values)
  } else {
    response = validateData(getValues, []);
  }

  return response;
};

/**
 * Change to options
 * @param {Object} element
 * @param {Object} field
 * @param {Object} data
 * @param {Function} setValue
 */
export const putSelect = (element, field, data, setValue = null) => {
  const { actualLanguage } = store.getState().base;
  const { [`data_${trimLowerCase(
    actualLanguage)}`]: staticData } = store.getState().staticData;
  const getValues = JSON.parse(element?.function_get_values);
  const response = validateData(getValues, staticData);
  let newValues;

  if (response && data) {
    Array.from(field.children).forEach((item, idx) => {
      if (idx !== 0) field.removeChild(item);
    });

    if (data?.searchSelect) {
      newValues = Array.from(response).filter(
        item => trimLowerCase(item?.codeParent) === trimLowerCase(data.value));
    } else {
      newValues = Array.from(response).filter(
        item => trimLowerCase(item[getValues?.compare]) === trimLowerCase(
          data[getValues?.search]));
    }

    if(data?.company_branches?.length){
      newValues = [...data?.company_branches]
    }

    Array.from(newValues).forEach(item => {
      const option = document.createElement('option');
      option.id = item[getValues?.id];
      option.value = item[getValues?.id];
      option.text = item[getValues?.value];
      option.setAttribute('data-type', 'new');
      if (getValues?.code) option.setAttribute('data-code', getValues?.code);
      if (data?.searchSelect) option.setAttribute(
        'data-parent', trimUpperCase(data.value));
      field.appendChild(option);
    });
    if (notUndefinedNull(setValue)) setValue(field.name, '');
    element.options = true;
  }
  if (newValues?.length === 0 || response?.length === 0 || !data) {
    element.options = false;
  }
};

/**
 * Evaluate default value in field type aux
 * @param {Object} field
 * @param {Function} setValue
 */
export const defaultAux = async (field, setValue, uniqueName = null) => {
  const { data: personData } = store.getState().personData;
  const defaultValue = (isUndefinedNull(field.default_value)) ? '' : JSON.parse(
    field.default_value);
  if (defaultValue?.type === 'set' && defaultValue?.fields) {
    defaultValueFieldsAux(defaultValue.fields, personData.id, setValue);
  }
  if (defaultValue?.type === 'endpoint') {
    let res = await endpointDefaultValue(field, setValue)
    return res
  }
  if (defaultValue?.type === 'static') setValue(uniqueName, defaultValue.text);
  if (defaultValue?.type === 'base') {
    if (defaultValue?.text) setValue(uniqueName, defaultValue.text.toUpperCase());
  }

};

/**
 * Add or remove attributes in field
 * @param {Object} field
 * @param {Object} attributes
 */
export const handleAttributes = (field, attributes) => {
  Array.from(attributes).forEach(attribute => {
    if (attribute?.name === 'checked') {
      field.checked = true;
    }
    if (attribute?.name === 'disabled') {
      field.disabled = true;
    }
    if (attribute?.name === 'not_disabled') {
      field.disabled = false;
    }
    if (attribute?.name === 'show') {
      field.value = '';
      const divGroup = fieldAttribute(
        'data-name', field.name, `div#group_field_${field.id}`);
      if (notUndefinedNull(divGroup)) {
        divGroup.classList.remove('d-none');
        if (notUndefinedNull(field?.id)) moduleCategory(field.id);
      }
    }
  });
};

/**
 * Get default value to endpoint
 * @param {Object} field
 * @param {Function} setValue
 */
export const endpointDefaultValue = async (field, setValue) => {
  const { action } = store.getState().tier;
  const defaultValue = (notUndefinedNull(field.default_value)) ? JSON.parse(
    field.default_value) : null;
  const actionValue = (notUndefinedNull(field.action)) ? JSON.parse(
    field.action) : null;
  const functionGetValues = (notUndefinedNull(
    field.function_get_values)) ? JSON.parse(field.function_get_values) : null;
  const condition = (notUndefinedNull(field.parent_condition)) ? JSON.parse(
    field.parent_condition) : null;
  let isSendEndpointData = true;
  let response

  if (notUndefinedNull(defaultValue) && functionGetValues.type === 'endpoint' && (
    action === paramsAdd || (action === paramsEdit && field.editable_after_migrate))) {
    let params = {};
    if (defaultValue.params === 'key') {
      Array.from(defaultValue?.fields).forEach(item => {
        const uniqueName = fieldUniqueName(item.name);
        if (uniqueName) {
          let value = uniqueName.value;
          if (value === hiddenField) {
            const { isValid, newValue } = checkValue(
              condition, setValue, false);
            value = (isValid) ? newValue : value;
          }
          isSendEndpointData = (value === hiddenField) ? false :
            isSendEndpointData;
          params[actionValue?.keys[item.name]] = value;
        }
      });
      functionGetValues.compare = params;
    }

    if (isSendEndpointData) {
      response = await sendGetEndpointData(functionGetValues);
      validateResponse(response, field, setValue, defaultValue?.action);
    } else {
      store.dispatch(setMessage(i18n.t("files.getFilesData"), 'error'));
      // Case document
      if (condition?.type === 'file') {
        const [nameField] = condition.condition;
        const allFields = fieldsUniqueName(nameField.name);
        let nameFieldValue, id;
        Array.from(allFields).forEach(item => {
          if (item.type === 'checkbox') {
            item.checked = false;
            item.disabled = false;
            nameFieldValue = item.name;
            id = item.dataset.fieldId;
          }
        });
        setValue(nameFieldValue, []);
        moduleCategory(id, true);
      }
    }
  }

  return response
};

/**
 * Validate the selected country of residence
 * @param {Object} elements
 * @param {Object} allowedCountries
 * @param {Object} tier
 * @returns
 */
export const validateCountry = (elements, allowedCountries, tier) => {
  let isValid = true;

  if (fieldsAllowedCountries?.[tier]) {
    Array.from(fieldsAllowedCountries[tier]).forEach(item => {
      if (elements?.[item] && isValid) {
        isValid = allowedCountries?.some(elem => trimUpperCase(
          elem.country_id) === trimUpperCase(elements[item]));
      }
    });
  }

  return isValid;
};

/**
 * Validate if an assistant is needed to complete a form
 * @param {String} location
 * @param {Array} assistantRules
 * @returns
 */
export const validateAssistantRule = (location, assistantRules) => {
  let needAssistant = false;

  if( notUndefinedNull(assistantRules)){
    Array.from(assistantRules).forEach(rule => {
      if (trimLowerCase(rule.country_code) === trimLowerCase(
        location) && rule.active) {
        needAssistant = true;
      } else if (rule.active) {
        needAssistant = true;
      }
    });
  }

  return needAssistant;
};


/**
 * Search list objects that satisfy denpendancy input condition
 * @param {Object} functionGetValues
 * @param {Object} formValues
 * @param {Array}  listObject
 * @param {Object} fieldAction
 * @returns
 */
export const searchDependentValue = async (functionGetValues, formValues, listObject, fieldAction) => {
  const [dependsValues] = functionGetValues?.depends || [];
  let result;
  let dependsField;
  if (functionGetValues.type === 'static_data' && typeof (
    dependsValues) === 'object') {
    dependsField = Array.from(Object.keys(formValues)).find(
      item => item.includes(dependsValues.field));
    if (notUndefinedNull(dependsField) && !isEmpty(formValues[
      dependsField]) && notUndefinedNull(formValues[dependsField])) {
      const searchedObject = await searchStaticData(
        dependsValues.name, dependsValues.search, formValues[dependsField]);
      if(listObject?.length){
        result = listObject.filter(item => item[
          dependsValues.search_value] === searchedObject?.[dependsValues.compare]);
      } else{
        let optionsProp = `${fieldAction.dependent_value}`
        result = searchedObject[`${optionsProp}`].map(result => {
          return {
            ...result,
            description: result.name || '',
            textValue: result.name || '',
            active: true,
            exclude: false,
            idValue: result.branch_id || null
          }
        })
      }
    }
  }

  return { result, dependsField };
};

/**
 * IMPORTANT description missing
 * @param {*} action
 * @param {*} value
 * @param {*} type
 * @param {*} setValue
 * @param {*} textValue
 */
export const actionTypeClick = (action, value, type, setValue, textValue) => {
  if (type === 'typeahead') {
    Array.from(action).forEach(item => {
      if (item.type === 'equal') {
        const inputTypeahead = fieldUniqueName(item.field);
        inputTypeahead.dataset.codeId = value;
        inputTypeahead.value = textValue;
        setValue(inputTypeahead.name, value);
      }
    });
  }
};

/**
 * IMPORTANT description missing
 * @param {*} currentLanguage
 * @param {*} date
 * @returns
 */
export const formatDate = (currentLanguage, date) => {
  const newDate = new Date(date);
  const day = currentLanguage === languagueEs ? ((newDate.getDate() < 10) ? `0${
    newDate.getDate()}` : newDate.getDate()) : (((newDate.getMonth() + 1) < 10) ? `0${
    newDate.getMonth() + 1}` : newDate.getMonth() + 1);
  const month = currentLanguage === languagueEs ? (((newDate.getMonth() + 1) < 10) ? `0${
    newDate.getMonth() + 1}` : newDate.getMonth() + 1) : ((newDate.getDate() < 10) ? `0${
      newDate.getDate()}` : newDate.getDate());
  return (`${day}/${month}/${newDate.getFullYear()}`);
};

/** 
  * Check if the app origin is Lendecy
  * @return {boolean} - Returns true if the app origin is Lendecy, false otherwise
  */
export const isLendecyApp = () => {
  const { appOrigin } = store.getState().user;
  return (appOrigin === appsOrigin.lendecy || appOrigin?.appOriginData === appsOrigin.lendecy);
}
/**
 * Retrieves all interactive form elements that are currently visible to the user.
 * This function filters elements by checking both their own visibility classes 
 * and the visibility of their parent modules (identified by [data-module]).
 *
 * @param {HTMLFormElement} form - The form element to scan for inputs.
 * @returns {Array<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement|HTMLCanvasElement>} 
 * An array of visible DOM elements that accept user input.
 */
export const getVisibleFormInputs = (form) => {
  // Use querySelectorAll to include non-form-control elements like CANVAS
  const tags = 'input, select, textarea, canvas';
  const allPotentialInputs = Array.from(form.querySelectorAll(tags));

  const visibleInputs = allPotentialInputs.filter(element => {
    // Check if the element itself is hidden
    const selfHidden = element.classList.contains('d-none');

    // Check if any ancestor with [data-module] is hidden
    const parentModuleHidden = element.closest('[data-module].d-none');

    // Exclude default hidden inputs if necessary
    const isTypeHidden = element.type === 'hidden';

    return !selfHidden && !parentModuleHidden && !isTypeHidden;
  });

  return visibleInputs
}

/**** Local functions  ****/
/**
 * Get app origin
 * @param {String} param
 * @returns
 */
const getAppOrigin = param => {
  const appParam = param;

  return { appParam };
};

/**
 * Get value to static_data/static/person_data
 * @param {Object} valuesData
 * @param {Object} data
 * @returns
 */
const validateData = (valuesData, data) => {
  const { appOrigin } = store.getState().user;
  let response = [];

  if (valuesData?.type === 'static') {
    const responseSplit = valuesData?.values.split(';');
    responseSplit.forEach(elem => {
      const value = elem.split(':').pop();
      const index = elem.split(':').shift();
      response.push(
        { idValue: index, textValue: value, codeValue: index, active: true });
    });
    response = sortElement(response, 'textValue');
  } else {
    const result = data?.[valuesData?.name];
    if (!result?.length && notUndefinedNull(result)) {
      response = result;
    } else {
      if (result) {
        const resultCopy = result.map(elem => ({ ...elem }));
        const { actualLanguage } = store.getState().base;
        resultCopy?.forEach((elem, index) => {
          let isSave = true;
          if (valuesData?.exclude) {
            const excludes = Array.from(valuesData.exclude).map(current => {
              if (valuesData?.parent) {
                let parentExclude = [...valuesData.parent];
                parentExclude = parentExclude.pop();
                if (valuesData?.app) {
                  if (trimLowerCase(valuesData.app).includes(trimLowerCase(
                    appOrigin)) && trimLowerCase(current?.value) === trimLowerCase(
                      elem[parentExclude.name][parentExclude.code])) {
                    return elem;
                  }
                } else {
                  if (trimLowerCase(current?.value) === trimLowerCase(elem[
                    parentExclude.name][parentExclude.code])) {
                    return elem;
                  }
                }
              } else {
                if (String(elem[current?.type]) !== hiddenField) {
                  if (valuesData?.app) {
                    if (trimLowerCase(valuesData.app).includes(trimLowerCase(
                      appOrigin)) && trimLowerCase(current?.value) === trimLowerCase(
                        elem[current?.type])) {
                      return elem;
                    }
                  } else {
                    if (trimLowerCase(current?.value) === trimLowerCase(elem[
                      current?.type])) {
                      return elem;
                    }
                  }
                }
              }
              return null;
            }).filter(current => notUndefinedNull(current));
            isSave = (excludes?.pop()) ? false : true;
          }
          if (isSave) {
            if (isUndefinedNull(elem?.active)) {
              resultCopy[index].active = true;
            }

            resultCopy[index].idValue = elem[valuesData?.id];
            resultCopy[index].textValue = elem[valuesData?.value];
            if (elem[`${valuesData?.value}_${trimLowerCase(actualLanguage)}`]) {
              resultCopy[index][`textValue_${trimLowerCase(actualLanguage)}`] = elem[
                `${valuesData.value}_${trimLowerCase(actualLanguage)}`];
            }

            resultCopy[index].exclude = !isSave;
            if (elem[valuesData?.code]) {
              resultCopy[index].codeValue = elem[valuesData.code].trim();
            }
            if (elem[valuesData?.change]) {
              resultCopy[index].codeId = elem[valuesData.change];
            }
            if (valuesData?.parent) {
              let parent = [...valuesData.parent];
              parent = parent.pop();
              resultCopy[index].codeParent = (elem[parent?.name]) ? elem[
                parent.name][parent.code] : elem[parent.code];
              if (parent.type === 'id') {
                resultCopy[index].codeId = resultCopy[index].codeParent;
              }
            }
            response.push(resultCopy[index]);
          }
        });
        response = sortElement(response, 'textValue');
      }
    }
  }

  return response;
};

/**
 * Search data
 * @param {Object} valuesData
 * @param {Object} data
 * @param {Function} setValue
 * @returns
 */
const searchData = async (valuesData, data, setValue) => {
  const putValues = valuesData?.put;
  let response;
  let result;

  response = await searchStaticData(
    valuesData?.name, valuesData?.search, valuesData?.compare);

  if (putValues) {
    result = [];
    const elements = putValues.split(',');
    Array.from(elements).forEach(elem => {
      const uniqueName = elem.split(':').shift();
      const value = elem.split(':').pop();
      const field = fieldUniqueName(uniqueName);
      let element = Array.from(data).filter(
        item => trimLowerCase(item.unique_name) === trimLowerCase(uniqueName));
      element = element?.pop();

      if (element?.id && field) {
        field.value = (response) ? response[value] : '';
        if (value !== 'function_get_values') {
          result.push({
            'uniqueName': `${uniqueName}__id__${element?.id}`,
            'value': (response) ? ((notUndefinedNull(
              response[value])) ? response[value] : null) : null
          });
        } else {
          putSelect(element, field, response, setValue);
        }
      }
    });
  }

  return result;
};

/**
 * Set default values
 * @param {Object} fields
 * @param {String} userId
 * @param {Function} setValue
 */
const defaultValueFieldsAux = (fields, userId, setValue) => {
  const { actualLanguage } = store.getState().base;
  const { field: fieldsData } = store.getState().staticData[
    `data_${trimLowerCase(actualLanguage)}`];
  Array.from(fields).forEach(item => {
    let itemField = Array.from(fieldsData).filter(child => (
      trimLowerCase(child.unique_name) === trimLowerCase(item.name)));
    let allField;
    itemField = itemField.pop();

    if (item.type === 'checkbox') {
      allField = [];
      const name = itemField.unique_name.split('__').pop();
      const elements = fieldsUniqueName(item.name);
      if (elements.length > 0) {
        Array.from(item.values).forEach((elem, index) => {
          elem.value = trimLowerCase(elem.value);
          if (elem.code === 'code') {
            let check = Array.from(elements).filter(child => (
              trimLowerCase(child.dataset?.code) === trimLowerCase(elem.value)));
            check = check?.pop();
            if (moduleCategory(check)) handleAttributes(check, item.attributes);
          }
          allField[index] = { user: userId };
          allField[index][name] = elem.value;
        });
      }
    }

    if (item.type === 'text') {
      let element = fieldUniqueName(item.name);
      if (notUndefinedNull(element)) {
        allField = '';
        handleAttributes(element, item.attributes);
      }
    }

    setValue(`${item.name}__id__${itemField.id}`, allField);
  });
};

/**
 * Validate response to endpoint
 * @param {Object} data        - Response of the API (document-condition) - 
 * @param {Object} field       - Field object, coming from self nomination (fields: ['document__search_type'])
 * @param {Function} setValue  - setValue function from RHF
 * @param {String} action      - 'default_value'.action                    (fields: ['document__search_type'])
 */
const validateResponse = (data, field, setValue, action) => {
  const actionValue = (notUndefinedNull(field.action)) ? JSON.parse(
    field.action) : null;
  const functionGetValues = (notUndefinedNull(
    field.function_get_values)) ? JSON.parse(field.function_get_values) : null;
  const condition = (field?.parent_condition) ? JSON.parse(
    field.parent_condition) : null;

  if (data[functionGetValues?.success]) {
    const result = (data[functionGetValues.success]);
    if (actionValue?.constants === 'fileCase' && condition.type === 'file') {
      setFileCases(
        functionGetValues.response, condition, setValue, action, result);
    }
  }
  if (data[functionGetValues.error]) {
    console.error('validateResponse: ', data[functionGetValues.error]);
  }
};


/**
 * Description placeholder
 *
 * @param {String} targetDay - String representing the target day as a number
 * 
 * @returns {number} - Number of days until target day
 */
const getNextDays = (targetDay)  => {
  const today = new Date()
  const currentDayIndex = (today.getDay() + 6) % 7

  /* Calculate number of days for next target day */
  const daysUntilTarget = ((targetDay || 0) - currentDayIndex + 7) % 7 || 7
  return daysUntilTarget
}

/**
 * Find value for options that should change (depending on other field's value) 
 * in radio buttons for dates (type = date_option)
 *
 * @param {Object} valuesData - Object that represents the field.function_get_value property.
 * @param {String} [changeOptionsValues=null] - String representing the selected option.
 * @returns {Array<Object>}
 */
const validateDateOption = (valuesData, changeOptionsValues = null) => {
  const { actualLanguage } = store.getState().base; 
  let response = [] // mm/dd/yyyy
  if (trimLowerCase(valuesData?.frequency) === 'weekly'){
    for (let i = 0; i < valuesData.size; i++) {
      const today = new Date()
      const finalDate = new Date(today)
      
      finalDate.setDate(finalDate.getDate() + (7*i)) // 7 is the number of days to move the date off
      if(changeOptionsValues) {
        const daysToAdd = getNextDays(changeOptionsValues)
        finalDate.setDate(finalDate.getDate() + daysToAdd)
      }
  
      const month = (finalDate.getMonth() + 1).toString().padStart(2, '0')
      const day   = finalDate.getDate().toString().padStart(2, '0')
      const year  = finalDate.getFullYear()
      let formattedDate
      if (trimLowerCase(actualLanguage) === 'en'){
        formattedDate = month + '/' + day + '/' + year;
      } else { 
        formattedDate = day + '/' + month + '/' + year;
      }
      const element = {
        idValue: formattedDate,
        codeValue: finalDate,
        id: i+1,
        active: true,
        textValue: formattedDate,
        description: formattedDate
      }
      response.push(element)
    }
  }
  return response
}


/**
 * Calculate the values for the auto date fields
 */
const calculateAutoDateValues = (getValues, frequencyValue, formValues) => {
  const base = store.getState().base;
  const { actualLanguage } = base;
  const { field: fields } = store.getState().staticData[`data_${trimLowerCase(actualLanguage)}`];
  const fieldsToDepend = getValues ? getValues.fields_to_depend : undefined;
  let options, currentOption
  if (fieldsToDepend){
    options = fieldsToDepend?.options
    currentOption = options.filter(option => String(option.value) === String(frequencyValue))[0]
    let currentOptionValue = formValues[Object.keys(formValues).find(key => key?.startsWith(currentOption?.baseField))]
    let calculation = calculateAutoDate(currentOptionValue, currentOption?.value, fieldsToDepend?.skip)
    return calculation
  }

}

/**
 * Calculate the final value to be set in the auto date field
 * @param {String} currentOptionValue - String representing the value for the current selected option. This value is
 *                 modelled as explained in the this documentation. https://aclaud.betternfaster.com/s/CyWz9GHmNiFj9cX  
 * @param {String} value - String representing the selected option. Where 2 means 'monthly', 6 means 'twice per month' 
 *                 and 3 means 'biweekly'.    
 */
const calculateAutoDate = (currentOptionDateValue, value, skip) => {
  let response
  /**
   * * Twice per month case
  */
  if (String(value) === String(6)) {
    // Simple case; no comma separated values
    if (!currentOptionDateValue?.includes(',')) {
      response = getNextIterationDateBimonhtly(currentOptionDateValue, skip)
    }
    // Complex case; comma separated values
    if (currentOptionDateValue?.includes(',')) {
      const dates = currentOptionDateValue.split('&')
      const firstDate = dates[0]
      const secondDate = dates[1]
      response = getNextOrdinalIterationDateBimonthly(firstDate)
      let ans1 = getNextOrdinalIterationDateBimonthly(firstDate)
      let ans2 = getNextOrdinalIterationDateBimonthly(secondDate)
      ans1 = new Date(ans1)
      ans2 = new Date(ans2)
      if (!skip) { // If not skipping, we need to get the closest next date
        response = ans1 < ans2 ? ans1 : ans2
      } else { // else we return the second closest date 
        response = ans1 > ans2 ? ans1 : ans2
      }
      response = formatDate('en', response)
    }
  }
  /**
   * * Monthly case
  */
  if (String(value) === String(2)) {
    // Simple case; single days
    if (!currentOptionDateValue?.includes(',')){
      response = getNextIterationDateBimonhtly(currentOptionDateValue)
      if (!skip) {
        // Return normally if not skippiing
        return response
      } else {
        // Return next month, if skipping
        if (response && datePattern.test(response)) {
          const [month, day, year] = response.split('/');
          const nextMonth = (Number(month)) % 12
          const nextYear = Number(month) === 12 ? Number(year) + 1 : year
          response = formatDate('en', new Date(nextYear, nextMonth, day))
        }
      }
    }
    // Complex case; Ordinal Weekdays
    if (currentOptionDateValue?.includes(',')){

      response = getNextOrdinalIterationDateBimonthly(currentOptionDateValue, skip)
      // Return normally if not skiping
      return response

    }
  }

  /**
   * * Biweekly case
  */
 if (String(value) === String(3)) {
    let choosenDate = new Date(currentOptionDateValue) 
    let secondNextDate = choosenDate.setDate(choosenDate.getDate() + 14)  
    secondNextDate = new Date(secondNextDate)
    return formatDate('en', secondNextDate)
 }

  return response
}

/**
 * Calculates the next iteration date for a bimonthly schedule based on the current date and a set of specified dates.
 *
 * @param {string} currentOptionDateValue - A string containing dates separated by '&'. Dates can be specific days of the month (e.g., '15') or special values ('-1' or 'last' for the last day of the month).
 * @returns {string} The next iteration date formatted as 'en'.
 *
 * @example
 * // Assuming today is December 24, 2024
 * const nextDate = getNextIterationDateBimonhtly('15&-1');
 * console.log(nextDate); // Outputs: 'December 31, 2024' (the last day of December 2024)
 */
const getNextIterationDateBimonhtly = (currentOptionDateValue, skip = false) => {
  // Obtaining data from current date
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth()
  const currentDate = today.getDate()

  let dates = currentOptionDateValue.split('&').map((date) => {
    if (date === '-1' || trimLowerCase(date) === 'last') {
      return getLastDayOfMonth(currentYear, currentMonth)
    }
    return Number(date)
  })

  // Breaking down the date and ordering the values
  dates = dates.map(Number).sort((a, b) => a - b)

  if (!skip){
    // Find next date in current month
    for (let date of dates) {
        if (date > currentDate) {
            return formatDate('en', new Date(currentYear, currentMonth, date))
        }
    }
  
    // If none of the dates are in the current month, find the first date in the next month
    const nextMonth = (currentMonth + 1) % 12;
    const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
    const firstDateNextMonth = dates[0] === getLastDayOfMonth(currentYear, currentMonth)
    ? getLastDayOfMonth(nextYear, nextMonth)
    : dates[0];
  
    return formatDate('en', new Date(nextYear, nextMonth, firstDateNextMonth))
  } else {
    // Find second next date in current month, if target day is prior to both payment days
    if (dates.every(date => date > currentDate)){
      return formatDate('en', new Date(currentYear, currentMonth, dates[1]))
    } else if (dates[0] <= currentDate && dates[1] > currentDate){
    // If target day is between the two payment days
      const nextMonth = (currentMonth + 1) % 12
      const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear
      const dateSecondPayment = dates[0] === getLastDayOfMonth(currentYear, currentMonth)
      ? dates[1]
      : dates[0]
      return formatDate('en', new Date(nextYear, nextMonth, dateSecondPayment))
    } else if (dates[0] <= currentDate && dates[1] <= currentDate){
    // If target day is after both payment days
      const nextMonth = (currentMonth + 1) % 12
      const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear
      const dateSecondPayment = dates[0] === getLastDayOfMonth(currentYear, currentMonth)
      ? dates[0]
      : dates[1]
      return formatDate('en', new Date(nextYear, nextMonth, dateSecondPayment))
    }
  }
}

const getLastDayOfMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate()
}

/**
 * Calculates the next iteration date for a bimonthly schedule based on the current date and a specified ordinal and day of the week.
 *
 * @param {string} input - A string containing the ordinal and day of the week separated by a comma (e.g., '2,0' for the second Monday).
 * @returns {string} The next iteration date formatted as 'en'.
 *
 * @example
 * Assuming today is December 24, 2024
 * const nextDate = getNextOrdinalIterationDateBimonthly('2,0');
 * console.log(nextDate); // Outputs: '01/13/2025' (the second Monday of January 2025)
 */
function getNextOrdinalIterationDateBimonthly(input, skip = false) {
  let [ordinal, dayOfWeek] = input.split(',').map(item => item.trim())

  // Convert 'last' to a flag
  const isLast = (ordinal === '-1' || trimLowerCase(ordinal) === 'last')
  if (!isLast) {
      ordinal = Number(ordinal)
  } else {
      ordinal = 'last'
  }

  dayOfWeek = Number(dayOfWeek)
  // Getting today's date
  const today = new Date()
  let year = today.getFullYear()
  let month = today.getMonth() 

  /**
   * * Finds the date of the last occurrence of a specific weekday in a given month.
   *
   * @param {number} year - The year of the desired month (e.g., 2024).
   * @param {number} month - The zero-based index of the month (0 for January, 11 for December).
   * @param {number} dayOfWeek - The zero-based index of the desired weekday (0 for Monday, 6 for Sunday).
   * @returns {Date} The date of the last occurrence of the specified weekday in the given month.
   *
   * @example
   * Find the last Friday (4) in December (11) of 2024
   * const lastFriday = findLastWeekdayOfMonth(2024, 11, 4);
   * console.log(lastFriday); // Outputs: Fri Dec 27 2024
   */
  const findLastWeekdayOfMonth = (year, month, dayOfWeek) => {
      const lastDayOfMonth = new Date(year, month + 1, 0) // Last day of the month
      const lastDayOfWeek = (lastDayOfMonth.getDay() + 6) % 7; // Adjusting to (Mon-Sun/0-6)
      const diff = (lastDayOfWeek >= dayOfWeek) ? lastDayOfWeek - dayOfWeek : 7 + lastDayOfWeek - dayOfWeek;
      return new Date(year, month, lastDayOfMonth.getDate() - diff)
  }

  /**
 * * Finds the nth occurrence of a specific weekday in a given month and year.
 *
 * @param {number} year - The year in which to find the nth weekday.
 * @param {number} month - The month (0-indexed, 0 = January, 11 = December) in which to find the nth weekday.
 * @param {number} dayOfWeek - The day of the week (0 = Monday, 6 = Sunday) to find.
 * @param {number} ordinal - The nth occurrence of the weekday to find (1 = first occurrence, 2 = second occurrence, etc.).
 * @returns {Date|null} The date of the nth weekday in the month, or null if it does not exist.
 *
 * @example
 * Find the 3rd Monday of October 2023
 * const date = findNthWeekdayOfMonth(2023, 9, 0, 3);
 * console.log(date); // Outputs: Mon Oct 16 2023
 */
  const findNthWeekdayOfMonth = (year, month, dayOfWeek, ordinal) => {
      const firstDay = new Date(year, month, 1)
      const firstDayOfWeek = (firstDay.getDay() + 6) % 7;// Adjusting to (Mon-Sun/0-6)
      const diff = (dayOfWeek - firstDayOfWeek + 7) % 7;
      const day = 1 + diff + (ordinal - 1) * 7;
      const lastDayOfMonth = new Date(year, month + 1, 0).getDate()
      if (day > lastDayOfMonth) return null
      return new Date(year, month, day)
  }

  // Calculate next date
  let nextDate
  const findNextDate = (year, month) => {
      if (isLast) {
        nextDate = findLastWeekdayOfMonth(year, month, dayOfWeek);
        return nextDate
      } else {
        nextDate = findNthWeekdayOfMonth(year, month, dayOfWeek, ordinal);
        return nextDate
      }
  }

  let candidateDate = findNextDate(year, month);
  if (!skip) {
    // Looking for the next date in the current month
    if (candidateDate && candidateDate > today) {
      return formatDate('en', candidateDate);
    } 
    // If there no date in the current month, find the first date in the next month
    month = (month + 1) % 12;
    if (month === 0) {
        year += 1;
    }
    candidateDate = findNextDate(year, month);
  } else {
    if (candidateDate && candidateDate > today) { // If the target day is after the current date we add one month for the 'second_next' date
      month = (month + 1) % 12
      if (month === 0) year += 1
    } 
    else{ // Else, we add two months for the 'second_next' date
      month = (month + 2) % 12
      if (month === 0 || month === 1) year += 1
    }
    candidateDate = findNextDate(year, month);
  }
  return formatDate('en' ,candidateDate);
}